import apiAgent from "../api/apiAgent";
import { useState } from "react";
import { tMsg } from "../components/ToastNotifications";
import { Button } from "../components/Button";
import { isValidEmail } from "../utils";
import { Link } from "react-router-dom";
import { Loader } from "../components/Loader";

interface IResetPasswordEmail {
  email: string;
}

const RequestReset = (): JSX.Element => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [formData, setFormData] = useState<IResetPasswordEmail>({
    email: "",
  });

  const sendRequest = async () => {
    try {
      setSubmitting(true);
      const response = await apiAgent.Auth.requestResetPassword(formData);
      if (response.status === 200) {
        tMsg.success(`Your reset request has been submitted`);
        setSubmitted(true);
      }
    } catch (err) {
      console.log(err);
      tMsg.error("Error sending request");
    } finally {
      setSubmitting(false);
      setFormData({
        email: "",
      });
    }
  };

  const handleSubmit = () => {
    if (!isValidEmail(formData.email)) {
      tMsg.error("Invalid email address");
      return;
    }
    sendRequest();
  };

  const updateFormData = (keyName: string, value: string) => {
    const newFormData = {
      ...formData,
      [keyName]: value,
    };
    setFormData(newFormData);
  };

  const SubmittedElement = () => (
    <>
      <h1 className="font-bold text-lg">Your request has been submitted</h1>
      <div className="text-sm my-4">
        You should receive an email shortly containing a link to reset your
        password. If you have not received an email within 10 minutes, please
        try again.
      </div>
      <div className="text-white/70 hover:text-white transition">
        <Link to="/login">Return to login page</Link>
      </div>
    </>
  );

  return (
    <div className="w-full h-full grid content-center bg-gray-700">
      <div className="space-y-4 flex flex-col justify-center">
        <div className="font-medium place-self-center w-64 space-y-4 text-center">
          {!submitted ? (
            <>
              <h1 className="font-bold text-lg">Reset your password</h1>
              <div className="text-sm">
                Enter the email address associated with your user account
              </div>
              <form className="grid place-items-center">
                <div className="my-4 space-y-2">
                  <div>Email</div>
                  <input
                    className="text-black p-1"
                    type={"email"}
                    value={formData.email}
                    onChange={(e) => {
                      e.preventDefault();
                      updateFormData("email", e.target.value);
                    }}
                    required
                  />
                </div>
                {submitting ? (
                  <Loader />
                ) : (
                  <Button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    Submit
                  </Button>
                )}
              </form>
            </>
          ) : (
            <SubmittedElement />
          )}
        </div>
      </div>
    </div>
  );
};

export default RequestReset;
